export function range(start: number, total: number): number[] {
	const a: Array<number> = [];
	for (let i = 0; i < total; i++) {
		a.push(start+i);
	}
	return a;
}


// WEBPACK FOOTER //
// ./src/utils/ArrayUtils.tsx